import React from "react";
import "./sendingLoading.scss";

//Imagens:
import ImgDataSending from "../../../../assets/realtimeData/dataSending.png";
import ImgDataLoading from "../../../../assets/realtimeData/dataLoading.png";
import { useTranslation } from "react-i18next";

function SendingLoading() {
  const { t } = useTranslation()

  return (
    <div className="container-sending-loading">
      <div className="div-sending">
        <div className="img-sending">
          <img src={ImgDataSending} alt="" />
        </div>
        <div className="texts-sending">
          <h1>{t("realtime_data.send_data.title")}</h1>
          <p>{t("realtime_data.send_data.section_text_1")}</p>
          <p>{t("realtime_data.send_data.section_text_2")}</p>
        </div>
      </div>
      <div className="div-loading">
        <div className="img-loading">
          <img src={ImgDataLoading} alt="" />
        </div>
        <div className="texts-loading">
          <h1>{t("realtime_data.load_data.title")}</h1>
          <p>{t("realtime_data.load_data.section_text_1")}</p>
          <p>{t("realtime_data.load_data.section_text_2")}</p>
        </div>
      </div>
    </div>
  );
}

export default SendingLoading;
